const userAgent = navigator.userAgent;
// 校验浏览器标识是PC、还是手机
const inMobile = /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i.test(userAgent);
const inPC = !inMobile;
// 校验是否是iOS系统
const inIos = /(iPhone|iPad|iPod|iOS)/i.test(userAgent);
// 校验是否是Android系统
const inAndroid = /(Android)/i.test(userAgent);
// 校验是否在大救星APP中
let inDjxApp = false;
if (inIos && window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.getStatusBarHeight) {
  inDjxApp = true;
} else if (inAndroid && window.JSInterface && window.JSInterface.getStatusBarHeight) {
  inDjxApp = true;
}
// 校验是否是微信浏览器
const inWxBrowser = /micromessenger/i.test(userAgent.toLowerCase());

// 校验是否运行在微信小程序 web-view 中
let inMiniProgram = false;
try {
  // 关键：必须在微信内，避免 APP/普通浏览器误判
  if (inWxBrowser) {
    if (window.__wxjs_environment === 'miniprogram') {
      inMiniProgram = true;
    } else if (typeof wx !== 'undefined' && wx.miniProgram) {
      // 部分机型/场景下 __wxjs_environment 不可用，用 wx.miniProgram 兜底
      inMiniProgram = true;
    } else if (/\bminiProgram\b/i.test(userAgent)) {
      // 兼容 UA 带 miniProgram 标识
      inMiniProgram = true;
    }
  }
} catch (e) {
  inMiniProgram = false;
}

/**
 * 运行时检测：是否为微信小程序 web-view（与静态 inMiniProgram 规则一致；wx 注入较晚时 mounted 再调更稳）
 * @returns {boolean}
 */
export function isMiniProgramWebView() {
  try {
    const ua = typeof navigator !== 'undefined' ? String(navigator.userAgent) : '';
    const inWx = /micromessenger/i.test(ua.toLowerCase());
    if (!inWx) return false;
    if (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram') return true;
    if (typeof wx !== 'undefined' && wx.miniProgram) return true;
    if (/\bminiProgram\b/i.test(ua)) return true;
  } catch (e) {
    // ignore
  }
  return false;
}

export default {
  inMobile,
  inPC,
  inIos,
  inAndroid,
  inDjxApp,
  inWxBrowser,
  inMiniProgram,
  isMiniProgramWebView
}



// WEBPACK FOOTER //
// ./src/assets/js/env.js